import styled, { css } from "styled-components";
import { CircularProgress } from "@mui/material";
import { Link as ScrollLink } from "react-scroll";
export const LinkContainer = styled(ScrollLink)`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 10px;

  text-align: center;
  text-transform: uppercase;
  font-family: "Mona-Sans", "Poppins", sans-serif;
  font-size: ${(props) => (props.$font ? props.$font : "24px")};
  letter-spacing: 1.5px;
  font-weight: 600;
  line-height: 25px;

  border-radius: 16px;
  border: 0;

  width: ${(props) => (props?.$width ? props?.$width : "fit-content")};
  height: ${(props) => (props?.$height ? props?.$height : "fit-content")};
  max-width: ${(props) =>
    props.$maxWidth !== undefined && props.$maxWidth !== ""
      ? props.$maxWidth
      : "379px"};

  padding: ${(props) => (props.$padding ? props.$padding : "38px 44px")};

  ${(props) =>
    props.$marginTop !== undefined &&
    props.$marginTop !== "" &&
    css`
      margin-top: ${(props) => props.$marginTop};
    `};

  background-color: ${(props) =>
    props.$color === "dark"
      ? props?.theme.colors?.dark
      : props?.theme.colors?.thertiary};
  color: ${(props) =>
    props.$color === "dark"
      ? props?.theme.colors?.thertiary
      : props?.theme.colors?.dark};
  &:disabled {
    color: ${(props) => props?.theme.colors.secondGray};
  }

  & svg * {
    fill: ${(props) =>
      props.$color === "dark"
        ? props?.theme.colors?.thertiary
        : props?.theme.colors?.dark};
  }

  & svg {
    margin-left: 7px;
  }

  & circle {
    r: 10;
    margin-top: 10px;
  }

  position: relative;
  cursor: pointer;

  @media (max-width: 768px) {
    font-size: ${(props) => (props.$font ? props.$font : "20px")};
    line-height: calc(
      0.79 * ${(props) => (props.$font ? props.$font : "20px")}
    );
    letter-spacing: 0.79px;
    padding: ${(props) => (props.$padding ? props.$padding : "30px 44px")};
    gap: 4px;
  }

  @media (max-width: 600px) {
    & svg {
      margin-left: 0px;
      ${(props) =>
        props.$iconSize &&
        `
      width: ${props.$iconSize};
      height: ${props.$iconSize};
    `}
    }
  }
`;
export const ButtonContainer = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 10px;
  white-space: nowrap;

  border: 0;
  border-radius: 16px;
  padding: ${(props) => (props.$padding ? props.$padding : "38px 44px")};

  width: ${(props) => (props?.$width ? props?.$width : "100%")};
  height: ${(props) => (props?.$height ? props?.$height : "fit-content")};
  max-width: ${(props) =>
    props.maxWidth !== undefined && props.maxWidth !== ""
      ? props.maxWidth
      : "379px"};

  font-family: "Mona-Sans", "Poppins", sans-serif;
  text-align: center;
  text-transform: uppercase;

  letter-spacing: 1.5px;
  font-size: ${(props) => (props.$font ? props.$font : "24px")};
  font-weight: 600;
  line-height: 25px;

  position: relative;
  cursor: pointer;

  background-color: ${(props) =>
    props.$color === "dark"
      ? props?.theme.colors?.dark
      : props?.theme.colors?.thertiary};
  color: ${(props) =>
    props.$color === "dark"
      ? props?.theme.colors?.thertiary
      : props?.theme.colors?.dark};

  &:disabled {
    color: ${(props) => props?.theme.colors.secondGray};
  }

  & svg * {
    fill: ${(props) =>
      props.$color === "dark"
        ? props?.theme.colors?.thertiary
        : props?.theme.colors?.dark};
  }

  & svg {
    margin-left: 7px;
  }
  & circle {
    r: 10;
    margin-top: 10px;
  }
  @media (max-width: 768px) {
    font-size: ${(props) => (props.$font ? props.$font : "20px")};
    line-height: calc(
      0.75 * ${(props) => (props.$font ? props.$font : "20px")}
    );
    letter-spacing: 0.79px;
    padding: ${(props) => (props.$padding ? props.$padding : "38px 44px")};
    gap: 4px;
  }

  @media (max-width: 600px) {
    & svg {
      margin-left: 0px;
      ${(props) =>
        props.$iconSize &&
        `
      width: ${props.$iconSize};
      height: ${props.$iconSize};
    `}
    }
  }
`;
export const Spinner = styled(CircularProgress)`
  width: 18px;
  height: 18px;
  color: ${(props) => props?.theme.colors?.secondGray};
  position: relative;
  top: 10px;
  position: absolute;
  top: 27%;
`;
